import { render } from "./backBtn.vue?vue&type=template&id=1fc7e00b&scoped=true"
import script from "./backBtn.vue?vue&type=script&lang=js"
export * from "./backBtn.vue?vue&type=script&lang=js"

import "./backBtn.vue?vue&type=style&index=0&id=1fc7e00b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc7e00b"]])

export default __exports__